// Reduces an iso code to its base subtag: "en-US" -> "en", "it-IT" -> "it", "EN" -> "en"
const baseLang = (iso?: string) => iso?.toLowerCase().split('-')[0];

export const getNameByLocale = (
    translations: Array<{ languageIsoCode: string; value: string }>,
    languages: Array<string> = ['en'],
) => {
    const normalizedLanguages =
        Array.isArray(languages) && languages.length > 0 ? languages : ['en'];

    const localizedName = normalizedLanguages
        .map(
            language =>
                // First an exact match, then a match on the base subtag normalizing both sides
                // so a browser locale like "en" matches a stored iso code like "en-US".
                translations.find(({ languageIsoCode }) => languageIsoCode === language) ??
                translations.find(
                    ({ languageIsoCode }) => baseLang(languageIsoCode) === baseLang(language),
                ),
        )
        .find(localized => localized !== undefined);

    return localizedName?.value || '';
};

export default getNameByLocale;
